import Menu from './components/Menu'; // Voorbeeld component
import Pillars from './components/Pillars';
import ResponsiveVideo from './components/ResponsiveVideo';
import Slider from './components/Slider';
import Backlink from './components/Backlink';
import IEcheck from './components/IEcheck';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

class Alfred {
	constructor() {
		// Promises waarop gewacht. Standaard wordt er gewacht op het 'DOMContentLoaded' event
		Promise.all([Alfred.domReady]).then(() => this.init());
	}

	init() {
		this.menu = new Menu();
		this.slider = new Slider();
		this.backlink = new Backlink();
		this.ResponsiveVideo = ResponsiveVideo.init();
		this.pillars = new Pillars();
		this.IEcheck = new IEcheck();
		setTimeout(() => {
			document.body.classList.add('body--loaded');
		}, 1000);
	}

	static domReady() {
		return new Promise((resolve) =>
			document.addEventListener('DOMContentLoaded', resolve),
		);
	}
}

new Alfred();

// jQuery document ready:

// (function($) {
// 	$('body').trigger('bless');
// })(jQuery);
